"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntlTranslationsProvider = exports.TranslationsProvider = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var locales_1 = require("../../locales");
var intlUtils_1 = require("./intlUtils");
var getNumericSymbols = function (intl) {
    return [locales_1.messages.k, locales_1.messages.m, locales_1.messages.g, locales_1.messages.t, locales_1.messages.p, locales_1.messages.e].map(function (desc) {
        return intl.formatMessage(desc);
    });
};
/**
 * @internal
 */
var TranslationsProvider = /** @class */ (function (_super) {
    tslib_1.__extends(TranslationsProvider, _super);
    function TranslationsProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TranslationsProvider.prototype.render = function () {
        var props = {
            numericSymbols: getNumericSymbols(this.props.intl),
            emptyHeaderString: intlUtils_1.emptyHeaderTitleFromIntl(this.props.intl),
            intl: this.props.intl,
        };
        return this.props.children(props);
    };
    return TranslationsProvider;
}(react_1.default.PureComponent));
exports.TranslationsProvider = TranslationsProvider;
/**
 * @internal
 */
exports.IntlTranslationsProvider = react_intl_1.injectIntl(TranslationsProvider);
//# sourceMappingURL=TranslationsProvider.js.map